export default function Circles({ order }) {
  const circles = order?.circles || [];
  
  return (
    <div className="circles">
      {circles.map(({ isGreen }, index) => (
        <div
          key={index}
          className={`circle circle-${isGreen ? 'green' : 'gray'}`}
        />
      ))}
    </div>
  );
}
